module.exports = __webpack_public_path__ + "img/bricks.f1dae926.png";